@if (!hasReadMore) {
    <sd-slider #pushSlider
               [brand]="brand"
               [customConfig]="pushSliderConfig"
               [items]="pushs"
               [size]="size"
               [itemTemplate]="pushCardTemplate"
               [context]="context"
               (slideNext)="onSlideChange($event)"
               (slidePrev)="onSlideChange($event)"
    />
  } @else {
    <sd-show-more [itemTemplate]="readMoreTpl" [showLessButton]="false" [size]="size" [items]="pushs">
      <ng-template #readMoreTpl let-push>
        <ng-container *ngTemplateOutlet="pushCardTemplate; context:{$implicit: push, hasReadMore: false}" />
      </ng-template>
    </sd-show-more>
  }

  <ng-template #pushCardTemplate let-item let-hasReadMore="hasReadMore">
    <article>
      <sd-push-card
        [indexFollow]="item?.indexFollow !== undefined ? item?.indexFollow : true"
        [brand]="brand ? brand : item?.brand ? item.brand : undefined"
        [isLoading]="isLoading"
        [textConfig]="item?.textConfig"
        [mediaConfig]="item?.mediaConfig"
        [mediaAsBackground]="item?.mediaAsBackground"
        [brandBar]="item?.brandBar"
        [push]="item?.push"
        [pushSize]="size"
        [imageRatio]="item?.imageRatio"
        [titleLevel]="titleLevel"
        [themesConfig]="item?.themesConfig"
        [isFit]="item?.isFit"
        [hasModal]="item?.hasModal"
        [isDescription]="hasReadMore || item?.isDescription"
        (videoPlayed)="onVideoPlayed(item)"
        (videoEnded)="onVideoEnded(item)"
        (clicked)="onClick($event, item?.push?.richParagraph?.heading?.data?.title)"
        [hasReadMore]="hasReadMore"
        [twicPicsAutoSize]="(pushs.indexOf(item) + 1) > numItemVisible ? true : twicPicsAutoSize"
      />
    </article>
  </ng-template>
